<template>
  <div
    v-if="showCommentPanel"
    class="comment">
    <ul
      v-if="comments.length > 0"
      class="list-unstyled p-2">
      <comment-item
        v-for="comment in comments"
        :key="comment.id"
        :latest-comment="isLatestComment(comment.id)"
        :is-period-over="isPeriodOver"
        :comment="comment" 
        :login-user-id="loginUserId" 
        :attachment-option="attachmentOption"
        @deletedComment="deletedComment" />
    </ul>
    <div
      v-if="!isPeriodOver && !isParentMember"
      class="mt-n2 p-2">
      <validation-observer
        ref="observer"
        v-slot="{passes}">
        <BaseTextareaWithProvider
          v-model="commentInput"
          name="コメント"
          placeholder="コメントを入力してください。"
          rows="5" />
        <div class="general-form__group form-group mt-3 mt-md-4">
          <validation-provider
            v-if="attachmentOption"
            v-slot="v"
            rules="file_size">
            <file-uploader
              v-model="file" />
            <p class="text-primary">
              {{ v.errors[0] }}
            </p>
          </validation-provider>
        </div>
        <button
          class="btn btn-l-blue btn-block mt-3"
          @click="passes(onClickAddComment)">
          コメントを追加
        </button>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CommentItem from '@/components/parts/CommentItem'
import FileUploader from '@/components/parts/FileUploader'
import BaseTextareaWithProvider from '@/components/parts/BaseTextareaWithProvider'

export default {
  components: {
    CommentItem,
    FileUploader,
    BaseTextareaWithProvider
  },
  props: {
    activityId: {
      type: String,
      required: true
    },
    comments: {
      type: Array,
      required: true
    },
    loginUserId: {
      type: String,
      required: true
    },
    attachmentOption: {
      type: Boolean,
      required: true
    },
    isPeriodOver: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      commentInput: '',
      file: null
    }
  },
  // 契約期間が終了していて、コメントが0件の場合はパネルを表示しない
  computed: {
    ...mapGetters('auth', ['isParentMember']),
    showCommentPanel() {
      if (this.isPeriodOver) {
        return this.comments.length > 0
      }
      return true
    }
  },
  methods: {
    onClickAddComment() {
      if (this.commentInput && this.commentInput !== ''|| this.file){
        this.$emit('createComment', this.activityId, this.commentInput, this.file)
        this.commentInput = ''
        this.file = null
      }
    },
    isLatestComment(id){
      if (this.comments.length === 0) return false
      if (id === this.comments.slice(-1)[0].id){
        return true
      }
      return false
    },
    deletedComment(commentId){
      this.$emit('deletedComment', this.activityId, commentId)
    },
  }
}
</script>
<style lang="scss" scoped>
.comment{
  background-color: $grey15;
}
</style>